import React, { useState, useContext, useEffect } from 'react'
import UserContextSeller from '@/product/context/seller/user/userContext'
import AuthContext from '../../../../product/context/auth/authContext'
import CustomCommonContext from '../../../context/common/commonContext'
import ProductCommonContext from '../../../../product/context/common/commonContext'
import commonContext from '@/product/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import UserContext from '../../../../product/context/user/userContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import ProductContext from '../../../../product/context/product/productContext'
import InvoiceContext from '../../../../product/context/invoice/invoiceContext'
import AuctionContext from '../../../../product/context/auction/auctionContext'
import CartContext from '../../../../product/context/cart/cartContext'
import BuyerContext from '../../../../product/context/buyer/buyerContext'
import AutopltContext from '../../../../product/context/autopilot/autopltContext'
import PayContext from '../../../../product/context/payment/payContext'
import StripeCardContext from '../../../../product/context/stripe/card/cardContext'
import StripeCustomerContext from '../../../../product/context/stripe/customer/customerContext'
import StripeBankContext from '../../../../product/context/stripe/bank/bankContext'

import SellerProductContext from '../../../../product/context/seller/product/productContext'
import SellerAuctionContext from '../../../../product/context/seller/auction/auctionContext'

import AppointmentContext from '../../../../product/context/appointment/appointmentContext'

const HeadAlert = () => {
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const customCommonContext = useContext(CustomCommonContext)
    const productContext = useContext(ProductContext)
    const payContext = useContext(PayContext)
    const cartContext = useContext(CartContext)
    const userContext = useContext(UserContext)
    const autopltContext = useContext(AutopltContext)
    const stripeBankContext = useContext(StripeBankContext)
    const stripeCardContext = useContext(StripeCardContext)
    const stripeCustomerContext = useContext(StripeCustomerContext)
    const sellerProductContext = useContext(SellerProductContext)
    const sellerAuctionContext = useContext(SellerAuctionContext)

    const productCommonContext = useContext(ProductCommonContext)
    // prettier-ignore
    const { loadUser, callEnd } = authContext
    const { getGlobalVariable, configVariables, allUISettings, socketModal } = customCommonContext
    const { getAllCountries, getAllStates, loaderSet, getAllCities } = productCommonContext

    const { setAlert } = alertContext
    const { responseStatus: responseStatusAuth, clearResponse: clearResponseAuth } = authContext

    const {
        responseStatus: responseStatusStripeCustomer,
        clearResponse: clearResponseStripeCustomer,
    } = stripeCustomerContext

    // prettier-ignore
    const {
        responseStatus: responseStatusStripeBank,
        clearResponse: clearResponseStripeBank,
    } = stripeBankContext

    // prettier-ignore
    const {
        responseStatus: responseStatusStripeCard,
        clearResponse: clearResponseStripeCard,
    } = stripeCardContext

    // prettier-ignore
    const {
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    // prettier-ignore
    const {
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = payContext

    const { responseStatus: responseStatusCart, clearResponse: clearResponseCart } = cartContext
    const { getAllUsers, all_users } = useContext(UserContextSeller)
    const {
        updateProfile,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = userContext

    // prettier-ignore
    const {
        responseStatus: responseStatusAutoPlt,
        clearResponse: clearResponseAutoPlt,
    } = autopltContext

    const {
        responseStatus: responseStatusSellerAuction,
        clearResponse: clearResponseSellerAuction,
    } = sellerAuctionContext

    const {
        responseStatus: responseStatusSellerProduct,
        clearResponse: clearResponseSellerProduct,
    } = sellerProductContext

    useEffect(() => {
        if (responseStatusUser) {
            if (!responseStatusUser.noAlert) {
                setAlert(responseStatusUser.message, responseStatusUser.status)
            }
            clearResponseUser()
        }
        if (responseStatusProduct) {
            if (!responseStatusProduct.noAlert) {
                setAlert(responseStatusProduct.message, responseStatusProduct.status)
            }
            clearResponseProduct()
        }
        if (responseStatusAutoPlt) {
            if (!responseStatusAutoPlt.noAlert) {
                setAlert(responseStatusAutoPlt.message, responseStatusAutoPlt.status)
            }
            clearResponseAutoPlt()
        }
        if (responseStatusAuth) {
            if (responseStatusAuth.from === 'register') {
                if (responseStatusAuth.status === 'success') {
                    setAlert('Successfully registered!', responseStatusAuth.status)
                    clearResponseAuth()
                } else {
                    setAlert(responseStatusAuth.message, responseStatusAuth.status)
                    clearResponseAuth()
                }
            } else {
                if (!responseStatusAuth.noAlert) {
                    setAlert(responseStatusAuth.message, responseStatusAuth.status)
                }
                clearResponseAuth()
            }
        }
        if (responseStatusPayment) {
            if (!responseStatusPayment.noAlert) {
                setAlert(responseStatusPayment.message, responseStatusPayment.status)
            }
            clearResponsePayment()
        }
        if (responseStatusCart) {
            if (!responseStatusCart.noAlert) {
                setAlert(responseStatusCart.message, responseStatusCart.status)
            }
            clearResponseCart()
        }

        if (responseStatusStripeBank) {
            if (!responseStatusStripeBank.noAlert) {
                setAlert(responseStatusStripeBank.message, responseStatusStripeBank.status)
            }
            clearResponseStripeBank()
        }

        if (responseStatusStripeCustomer) {
            if (!responseStatusStripeCustomer.noAlert) {
                setAlert(responseStatusStripeCustomer.message, responseStatusStripeCustomer.status)
            }

            clearResponseStripeCustomer()
        }

        if (responseStatusStripeCard) {
            if (!responseStatusStripeCard.noAlert) {
                setAlert(responseStatusStripeCard.message, responseStatusStripeCard.status)
            }
            clearResponseStripeCard()
        }
        if (responseStatusSellerProduct) {
            if (!responseStatusSellerProduct.noAlert) {
                setAlert(responseStatusSellerProduct.message, responseStatusSellerProduct.status)
            }
            clearResponseSellerProduct()
        }
        if (responseStatusSellerAuction) {
            if (!responseStatusSellerAuction.noAlert) {
                setAlert(responseStatusSellerAuction.message, responseStatusSellerAuction.status)
            }
            clearResponseSellerAuction()
        }
    }, [
        responseStatusUser,
        responseStatusProduct,
        responseStatusAutoPlt,
        responseStatusAuth,
        responseStatusPayment,
        responseStatusCart,
        responseStatusStripeBank,
        responseStatusStripeCustomer,
        responseStatusStripeCard,
        responseStatusSellerProduct,
        responseStatusSellerAuction,
    ])

    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    if (responseStatusPayment.data && responseStatusPayment.data.url) {
                        const newWindow = window.open(
                            responseStatusPayment.data.url,
                            '_self',
                            'noopener,noreferrer',
                        )
                        if (newWindow) newWindow.opener = null
                    }
                }
            }
        }
    }, [responseStatusPayment])

    useEffect(() => {
        if (responseStatusStripeCustomer) {
            if (responseStatusStripeCustomer.status === 'success') {
                if (responseStatusStripeCustomer.from == 'create') {
                    updateProfile({ stripe_id: responseStatusStripeCustomer.data.id }, true)
                }
            }
        }
    }, [responseStatusStripeCustomer])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'updatePreference' ||
                responseStatusUser.from === 'userAddress'
            ) {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                }
            }
        }
    }, [responseStatusUser])

    useEffect(() => {
        loaderSet(true)
        if (localStorage.token) {
            loadUser(localStorage.token)
        } else {
            loaderSet(false)
        }
        getAllUsers(
            {
                email: '',
                first_name: '',
                last_name: '',
                page: 1,
                limit: 1000,
                order: '',
                orderby: '',
                filters: {
                    action: {
                        value: '4',
                        type: 'in',
                        field: 'u.user_type',
                    },
                },
            },
            'rm_retailer',
        )
        getGlobalVariable()
        // getAllCountries()
        getAllStates()
        getAllCities()
    }, [])

    useEffect(() => {
        if (callEnd) loaderSet(false)
    }, [callEnd])

    // useEffect(() => {
    //     if (allUISettings) {
    //         allUISettings.map((data, index) => {
    //             if (data.ui_key == 'primColor') {
    //                 document.documentElement.style.setProperty('--primColor', data.ui_value)
    //             } else if (data.ui_key == 'secColor') {
    //                 document.documentElement.style.setProperty('--secColor', data.ui_value)
    //             }
    //         })
    //     }
    // }, [allUISettings])

    const [toggleDisconnectDialog, setToggleDisconnectDialog] = useState(false)
    const changeDisconnectDialogStatus = () => {
        setToggleDisconnectDialog(!toggleDisconnectDialog)
    }
    function refreshPage() {
        window.location.reload(false)
    }
    useEffect(() => {
        if (socketModal) {
            setToggleDisconnectDialog(true)
        }
    }, [socketModal])
    return (
        <>
            {' '}
            <CustomDialog
                title={'Connection Disrupted'}
                open={toggleDisconnectDialog}
                disableBackdropClick={true}
                function={changeDisconnectDialogStatus}
            >
                <h5>It appears that your connection has been disrupted.</h5>
                <h5>Please click the Reload button or refresh your browser.</h5>

                <div className="actionWrapper">
                    <PrimaryButton type="button" onClick={() => refreshPage()} label="RELOAD" />
                </div>
            </CustomDialog>
        </>
    )
}
export default HeadAlert
